// Create a form based on given data
const constructFormData = (obj, method, url, verifyParametersData)  => {
    const form = obj.createElement('form');
    form.setAttribute('method', method || 'POST');
    form.setAttribute('action', url);
    let charsetField = obj.createElement('input');
    charsetField.setAttribute('type', 'hidden');
    charsetField.setAttribute('name', '_charset_');
    charsetField.setAttribute('value', 'UTF-8');
    form.appendChild(charsetField);
    Object.entries(verifyParametersData).forEach(([key, value]) => {
        let hiddenField = obj.createElement('input');
        hiddenField.setAttribute('type', 'hidden');
        hiddenField.setAttribute('name', key);
        hiddenField.setAttribute('value', value);
        form.appendChild(hiddenField);
    });
    return form;
};

/**
 * Perform 3DS method in an iframe, or redirect user to needed url
 * @param {Object} obj. only 2 available choices for now: an iframe or a Document (for redirection)
 * @param {String} method. the 3DS method. For example: 'POST', 'GET'
 * @param {String} url. url to perform the method on.
 * @param {Dict} verifyParametersData hidden data needed for the 3DS method. 
 * @return nothing. The form is submitted to perform the 3DS method
 */
export const perform3DSMethod = (obj, method,  url, verifyParametersData) => {
    let chosenObj;
    if (obj instanceof HTMLIFrameElement) {
        chosenObj = obj.contentDocument;
    }else if (obj instanceof Document) {
        chosenObj = obj;
    } else {
        console.error('Object to perform 3DS steps must be of type Document or an iFrame');
        return;
    }

    let form = constructFormData(chosenObj, method, url, verifyParametersData);

    if (obj instanceof HTMLIFrameElement) {
        chosenObj.documentElement.appendChild(form);
    } else {
        chosenObj.body.appendChild(form);
    }

    form.submit();
};
